<template>
    <div class="welcome-page  text-center">
        <div class="bg-img">
            <div class="logo-container text-center">
                <img src="@/assets/img/logo/jcb-logo@1x.png" alt="JCB Logo" />
            </div>
            <div class="text-white">
                JOIN TO
            </div >
            <div class="text-2xl text-white mt-2">
                {{ lbl.welcome.headers.line1 }}
            </div>
        </div>
        <div class="py-5">
            <div class="btn-line-connect mx-9 mb-4" @click="goToRegister()">
                <div class="text-white flex justify-center items-center h-full">{{ lbl.welcome.headers.line2 }}</div>
            </div>
            <div class="btn-jcb-card mx-9 mb-4" @click="goToApply()">
                <div class="text-blue-1 flex justify-center items-center h-full">Apply JCB Card</div>
            </div>
            <div class="text-center">
                <img class="mx-auto" src="@/assets/img/logo/buzzebees-logo-dark-semi.svg" />
            </div>
        </div>
        <!-- <TopBarBg :headerText="lbl.sidemenu.contact_us" sideMenu></TopBarBg>
        <PageContent class="flex-auto" :hasPoweredBy="hasPoweredBy" rounded>
            <div class="px-5">
                <div class="text-center">
                    <img class="mx-auto" src="@/assets/icon/misc/contact-us-icon.svg">
                    <div class="text-primary text-base mt-5">
                        {{ lbl.contact_us.contact_information }}
                    </div>
                    <div class="text-sm text-gray-secondary mt-2">
                        {{ lbl.contact_us.detail }}
                    </div>

                </div>
            </div>
        </PageContent>
        <Footer :hasPoweredBy="hasPoweredBy" /> -->
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>
    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
// import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
// import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import ModalMaster from "@/components/Modal/ModalMaster.vue"

// mixin
import ModalMixin from "@/mixin/ModalMixin"
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"

export default {
    name: "FAQPage",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        // TopBarBg,
        // PageContent,
        Footer,
        ModalMaster,
        // ButtonFBMessenger,
        // ButtonEmailMessenger,
    },
    data: function () {
        return {
            hasPoweredBy: false,
            trackingScreenName: 'welcome',
        }
    },
    created: function () {
        this.tracking.screenName(this.trackingScreenName);
    },
    methods: {
        goToApply: function(){
            this.tracking.event('welcome', 'click_apply_card', null, null);
            this.$router.replace({
                name: "apply-card"
            })
        },
        goToRegister: function(){
            this.tracking.event('welcome', 'click_register', null, null);
            this.$router.replace({
                name: "register"
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .welcome-page{
        background-image: linear-gradient(to top, #1c2c73 28%, #1a3077 17%, #016cb8);
        min-height: 100vh;

        .bg-img{
            background-image: url('~@/assets/img/bg/bg-welcome.png');
            height: 600px;
            width: 100%;
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }

        .btn-line-connect{
            height: 55px;
            background: url("~@/assets/button/btn-line-connect.svg");
            background-size: 100% 100%;
        }
        .btn-jcb-card{
            height: 55px;
            background: url("~@/assets/button/btn-jcb-card.svg");
            background-size: 100% 100%;
        }
    }
    .logo-container {
        padding-top: 42px;
        padding-bottom: 25px;

        img {
            margin-left: auto;
            margin-right: auto;
        }
    }
    .line-text{
        width: 45px;
        height: 1px;
        flex-grow: 0;
        margin: 15px 12px;
        background-color: #e3e8f3;
    }
</style>

